import { scrollToSection } from 'common/utilities/browser/scroll/scroll';
import { closeFullscreenTableAction } from 'core/redux/actions/ui/uiActions';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { AnyAction,Middleware } from 'redux';
import { LOCATION_CHANGE } from 'redux-first-history';

const scrollMiddleware: Middleware = (store) => (next) => (action: AnyAction) => {
  const state = store.getState() as ApplicationState;

  if (closeFullscreenTableAction.match(action)) {
    const id = action.payload.tableId;

    if (id) {
      setTimeout(() => {
        scrollToSection(id, state.ui.showAppHeaderEnv);
      }, 500);
    }
  }

  if (state.ui.fullscreenTable && action.type === LOCATION_CHANGE) {
    store.dispatch(closeFullscreenTableAction());
  }

  next(action);
};

export default scrollMiddleware;
